import React, { useContext, useEffect } from 'react';
import { Box, Tabs, Tab, useMediaQuery } from '@material-ui/core';
import TabPanel from './TabPanel';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import GenerateCards from '../generate-cards/GenerateCards.component';
import leftPanelStyle from './LeftPanel.style';
import {
	HEADER_PART_ONE,
	HEADER_PART_TWO,
	HEADER_PART_THREE,
	TEMPLATE_TABS,
	TEMPLATE_TABS_WITHOUT_CANNED_REPORTS,
	GENERAL_CANNED_REPORT_LIST,
	PERSONA
} from 'constants/constant';
import { UserPortalContext } from 'context/appcontext';
import { saveItemShareStatus } from '../../Preview/Preview.actions';
import { DatasetPanel } from './DatasetPanel.component';

const LeftPanel = (props) => {
	const { setShow, show } = props;
	const dispatch = useDispatch();
	const [value, setValue] = React.useState(0);
	const isSmallScreen = useMediaQuery('(max-width:600px)');
	const classes = leftPanelStyle({ show });

	const templateData = useSelector((state) => state.templateReducer.templateData);
	const cannedReportData = useSelector((state) => state.templateReducer.cannedReportData);

	const portalUserContext = useContext(UserPortalContext);
	const { userDetails } = portalUserContext;
	const { userPersona } = userDetails?.result;

	const haveGeneralCannedReport = cannedReportData?.some((item) => {
		return GENERAL_CANNED_REPORT_LIST.includes(Number(item?.templateId));
	});

	const TABS =
		haveGeneralCannedReport ||
		(cannedReportData?.length > 0 && ![PERSONA.CATMAN, PERSONA.BASIC_CATMAN].includes(userPersona))
			? TEMPLATE_TABS
			: TEMPLATE_TABS_WITHOUT_CANNED_REPORTS;

	const handleChange = (event, newValue) => {
		setValue(newValue);
		setShow(false);
	};

	useEffect(() => {
		dispatch(saveItemShareStatus({ prev: false, curr: false }));
	}, []);

	function templateTabs() {
		return (
			<>
				<Tabs
					value={value}
					classes={{
						root: classes.tabsRoot,
						indicator: classes.tabsIndicator
					}}
					variant={isSmallScreen ? 'fullWidth' : 'standard'}
					onChange={handleChange}
					aria-label="template tabs"
					indicatorColor="primary">
					{TABS.map((item) => (
						<Tab label={item} key={item} classes={{ root: classes.tabRoot }} />
					))}
				</Tabs>

				<TabPanel value={value} index={0} padding={3}>
					<DatasetPanel setShow={setShow} templateData={templateData} />
				</TabPanel>
				<TabPanel value={value} index={1} padding={3}>
					<GenerateCards setShow={setShow} templateData={cannedReportData} />
				</TabPanel>
			</>
		);
	}

	return (
		<Box>
			<Box className={classes.heading}>
				{HEADER_PART_ONE}
				<span className={classes.textHighlight}> {HEADER_PART_TWO} </span>
				{HEADER_PART_THREE}
			</Box>
			{templateTabs()}
		</Box>
	);
};

LeftPanel.propTypes = {
	setShow: PropTypes.func.isRequired
};

export default LeftPanel;
